<template>
    <div class="report-result marriage-report-result">
        <!-- 1、个人姻缘综合得分 -->
        <div id="mrgBox1" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>个人姻缘综合得分</span></div>
                <div class="marriage-content-content">
                    <div class="marriage-content-score-box" v-if="marriageData">
                        <div class="marriage-content-score">
                            <span class="score-num">{{ marriageData.totalScore || marriageFavorableInfoData.totalScore }}<span class="score-text">分</span></span>
                        </div>
                        <div class="marriage-content-info" v-if="marriageOneInfoData && marriageOneInfoData.total">
                            <span class="info-text" v-for="text in marriageOneInfoData.total.des">{{ text }}</span>
                        </div>
                    </div>
                    <div class="marriage-content-c-content" v-if="marriageData.is_pay == 0">
                        <div class="marriage-content-c-title">智能月老综合解读：</div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div class="marriage-content-mask1" v-if="marriageData.is_pay == 0 && productData">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div class="marriage-content-c-content" v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.total">
                        <div class="marriage-content-c-title">月老综合评定</div>
                        <p class="marriage-content-c-p" v-for="adviceText in marriageOneInfoData.total.singleAdvice">{{ adviceText }}</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 2、主人生日能量评测 -->
        <div id="mrgBox2" class="marriage-content-box-box">
            <div class="marriage-content-box-border pr">
                <div class="marriage-little-bg little-bg3"></div>
                <div class="marriage-content-title"><span>主人生日能量评测</span></div>
                <marriage-energy-one></marriage-energy-one>
                <div class="marriage-content-c-content marriage-content-c-content2 marriage-content-content-bg">
                    <div class="marriage-content-c-label"><span>常识误区</span></div>
                    <p class="marriage-content-c-p">常识误区：五行缺失，但不代表需要加强，而代表该五行对应的一些天赋能力的缺失，从根本上需要从后天练习来补充。通过佩戴相关颜色或手饰虽然治标不治本但也能起到一定的加分加成作用，考虑到配合运势的助力，建议大家优先选择所喜五行，而不是所缺的五行。</p>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 3、婚姻观 -->
        <div id="mrgBox3" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>婚姻观</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image1"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">这里是你的先天婚姻观，婚姻观会随着成长环境或者后天教育及成长经历发生一些变化，但是内心深处的痕迹依然会伴随我们终身。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div class="marriage-content-mask1" v-if="marriageData.is_pay == 0 && productData">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-else class="marriage-content-c-content marriage-content-c-content-bg">
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.marriageView">{{ text }}</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 4、夫妻星的稳定性 -->
        <div id="mrgBox4" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>夫妻星的稳定性</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image2"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">按照传统的观念来看，夫妻星越稳定越好，而越动荡则代表着婚姻的风险越大，所以古人合婚是必看夫妻星的吉凶状态的。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.spouseStar" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageOneInfoData.spouseStar.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p">分数说明：如果此项分数较低，适合匹配此项分数较高的对象；两人合分才会更准确，两位分数都较高的话可以理解为吉上加吉，一位较高而另一半较低则会稍稍均衡，如果两位分数都较低的话就是负向加重出问题的概率，要更加注意；但需强调的是，单项评分由于权重各有差异就算分数再低也不能说明最终等级结果，最终结果以最上面的综合评分为准。</p>
                        <p class="pad-t-1"></p>
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.spouseStar.des">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">夫妻星越稳定分越高，说明对象越稳定越安静，夫妻星越活跃分越低，说明对象很活跃，动静比较大，但时过境迁，无数大数据案例已经印证了，夫妻星动荡未必代表凶，可以理解为对象是从事动荡比较大的工作，或者出差比较多，只是要注意的是越活跃容易增加，两口子惹事生非的概率。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 5、夫妻宫的稳定性 -->
        <div id="mrgBox5" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>夫妻宫的稳定性</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image3"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">夫妻宫也是古人合婚的重要指标，古人喜欢夫妻宫安定详和，而现代人相对来说由于社会性质和活动范围发生巨大变化，夫妻宫的不稳定可能表现跟工作等相关，不再一味代表着凶，但依然可作风险规避的参考。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.palaceStability" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageOneInfoData.palaceStability.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.palaceStability.des">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">夫妻宫越稳定分越高，说明家宅越安宁，夫妻宫越活跃分越低，说明家里动静越大，但未必代表凶，也可能代表家里总有人出入，比如夫妻俩有人出差比较多，或者聚少离多。如果此项分数较低，则尽可能匹配此项分数较高的对象，更利于趋吉避凶。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 6、夫妻宫与工作和谐度 -->
        <div id="mrgBox6" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>夫妻宫与工作和谐度</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image4"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">这部分通常能看出一个人的工作、事业与家庭的冲突情况，需要自己根据自己的情况来取舍自身重心放在哪里，找到适当的平衡点。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.dayMonthRelation" class="marriage-content-c-content">
                        <div class="marriage-content-score-box">
                            <div class="marriage-content-score small">
                                <span class="score-num">{{ marriageOneInfoData.dayMonthRelation.score }}<span class="score-text">分</span></span>
                            </div>
                        </div>
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.dayMonthRelation.des">{{ text }}</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 7、桃花出现的时间预测 -->
        <div id="mrgBox7" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>桃花出现的时间预测</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image5"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">如果你还单身，请特别留意以下时间可能出现的缘分，抓住时机可以事半功倍。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.peachLuck" class="marriage-content-c-content">
                        <div class="marriage-content-c-title">一般注意时间：</div>
                        <p class="marriage-content-c-p p-t5"><span v-for="item in marriageOneInfoData.peachLuck.favorable_months.slice(0, 3)">{{ item.time }}</span></p>
                        <p class="marriage-content-c-p p-t5"><span v-for="item in marriageOneInfoData.peachLuck.favorable_months.slice(3)">{{ item.time }}</span></p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">再好的机缘出现，如果不行动，只是守株待兔那也可能是错失良机；所以选择在合适的机会主动出击才是脱单妙计。如果你已经脱单，那要注意以上时间可能会有别的桃花，安分守己为好。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 8、未来配偶的画像 -->
        <div id="mrgBox8" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>未来配偶的画像</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image6"></div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.spouseFeatures" class="marriage-content-c-content">
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">对象性格：</span></p>
                        <p class="marriage-content-c-p">{{ marriageOneInfoData.spouse.spouseFeatures.personality }}</p>
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">可能的姓：</span></p>
                        <p class="marriage-content-c-p">
                            {{ marriageOneInfoData.spouse.spouseFeatures.first_name.join(' ') }}
                        </p>
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">年龄描述：</span></p>
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.spouse.spouseAge">{{ text }}</p>
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">方位描述：</span></p>
                        <p class="marriage-content-c-p" v-for="text in marriageOneInfoData.spouse.spouseDirection.physical">{{ text }}</p>
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">与你的关系：</span></p>
                        <p class="marriage-content-c-p p-t5">{{ marriageOneInfoData.spouse.spouseDirection.relation }}</p>
                        <p class="marriage-content-c-p"><span class="marriage-content-c-title">与父母的关系：</span></p>
                        <p class="marriage-content-c-p p-t5" v-for="text in marriageOneInfoData.spouse.parentRelationship">{{ text }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">以上信息仅供参考，毕竟相同生日生辰的人很多，不可能每个人的对象都是一样的情况，会受后天的选择，从事的行业等方方面面的影响而产生偏差，但是顺着先天所带这些信息去寻找另一半，效率会更高。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 9、结婚生子的时间预测 -->
        <div id="mrgBox9" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>结婚生子的时间预测</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image7"></div>
                    <div class="marriage-content-quote">
                        <div class="quote-icon quote-icon-left"></div>
                        <div class="quote-content">如果你尚未婚娶生子，则可参考以下时间谈婚论嫁，把握良机，顺应天意；如果你已婚娶生子，那么要注意下面的结婚时间可能是下一波桃花的时间，要特别注意防范；而生子时间则代表再添新子的时机。</div>
                        <div class="quote-icon quote-icon-right"></div>
                    </div>
                    <!-- 未解锁状态 -->
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <!-- 已解锁状态 -->
                    <div v-if="marriageData.is_pay !== 0 && marriageOneInfoData && marriageOneInfoData.marriageTime && marriageOneInfoData.childrenTiming" class="marriage-content-c-content">
                        <div class="marriage-content-c-title">结婚时间预测：</div>
                        <p class="marriage-content-c-p p-t5">{{ marriageOneInfoData.marriageTime.miss.concat(marriageOneInfoData.marriageTime.info).join(' ') }}</p>
                        <div class="marriage-content-c-title pad-t-h1">生子时间预测：</div>
                        <p class="marriage-content-c-p p-t5">{{ marriageOneInfoData.childrenTiming.miss.concat(marriageOneInfoData.childrenTiming.info).join(' ') }}</p>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <div class="marriage-content-c-label"><span>解读说明</span></div>
                        <p class="marriage-content-c-p">生日生辰相同的人每天都很多，但是结婚生子的可能性会非常之多，主要原因是，一个人只决定了一半的时间信息，另一半的时间信息合在一起才会使得最终生育时间锁定更准确，可以参考二人合婚测算。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>
        <!-- 10、月老关于婚姻的针对性建议 -->
        <div id="mrgBox10" class="marriage-content-box-box"></div>
        <!--<div id="mrgBox10" class="marriage-content-box-box">
            <div class="marriage-content-box-border">
                <div class="marriage-content-title"><span>月老关于婚姻的针对性建议</span></div>
                <div class="marriage-content-content" :class="{'marriage-content-content-bg' : marriageData.is_pay != 0}">
                    <div class="marriage-content-image image8"></div>
                    <div v-if="marriageData.is_pay == 0 && productData" class="marriage-content-mask2">
                        <marriage-report-button
                            v-bind:buttonText="productData.price+'元解锁本页报告'"
                            v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                            v-bind:clickFunc="clickPay">
                        </marriage-report-button>
                    </div>
                    <div v-if="marriageData.is_pay !== 0" class="marriage-content-c-content">
                        <p class="marriage-content-c-p">A大米盼着婚姻简单纯粹，寻个灵魂相契、话语投机的人。共赴柴米油盐，同享笑语欢声，不求轰轰烈烈，唯愿真诚相待、彼此尊重。在漫长流年里，把平凡光景，过成相互最珍贵的依赖，让日子浸着踏实的甜。</p>
                        <p class="marriage-content-c-p">A大米盼着婚姻简单纯粹，寻个灵魂相契、话语投机的人。共赴柴米油盐，同享笑语欢声，不求轰轰烈烈，唯愿真诚相待、彼此尊重。在漫长流年里，把平凡光景，过成相互最珍贵的依赖，让日子浸着踏实的甜。共赴柴米油盐，同享笑语欢声，唯愿真诚相待、彼此尊重。</p>
                    </div>
                </div>
                <div class="marriage-content-bottom-border"></div>
            </div>
        </div>-->
        <!-- 11、结束语 -->
        <div class="marriage-result-content-bottom">
            <div class="marriage-result-content-bottom-title">
                <span class="title-icon icon-left"></span>
                <span class="title-text">结束语</span>
                <span class="title-icon icon-right"></span>
            </div>
            <div class="marriage-result-content-bottom-text">
                <p>总之，人生也好，婚姻也好，她都像天气预报一样是一道虽未知结果但有规律的计算题，无论她的先天状况是好是坏，她都有最优解，而最终结果都是由我们在知己知彼知道以上情况的前提下进行书写，提前预知并适当调整、优化，最终达成双方婚姻家庭的幸福、美满！这也就是古人发明合婚的初衷和意义，而不要封建迷信地去因为看到分数不好而受到惊吓或者恐惧，而应该庆幸知道就可能主动趋利避害。</p>
                <p>最后祝天下有情人终成眷属，婚姻幸福美满到永久！</p>
            </div>
        </div>
        <!-- 12、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import MarriageReportButton from './MarriageReportButton.vue'
import MarriageEnergyOne from './MarriageEnergyOne.vue';
import { CONFIG } from '../../modules/config'
import { MARRIAGE_DOM } from '../../modules/dom';
export default {
    name: 'MarriageReportOneResult',
    components: { MarriageReportButton, MarriageEnergyOne },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        marriageProductData() {
            return this.$store.state.pay.marriageProductData;
        },
        marriageFavorableInfoData() {
            return this.$store.state.marriage.marriageFavorableInfoData;
        },
        marriageData() {
            return this.$store.state.marriage.marriageData;
        },
        productData() {
            return this.$store.state.pay.marriageProductData[this.$store.state.marriage.marriageData.pid];
        },
        marriageOneInfoData() {
            return this.$store.state.marriage.marriageOneInfoData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
        }
    },
    mounted() {
        this.$bus.on('showMarriageReportSuc', this.showMarriageReportSuc);
        this.$bus.on('triggerReportOnePay', this.clickPay);
    },
    destroyed() {
        this.$bus.off('showMarriageReportSuc', this.showMarriageReportSuc);
        this.$bus.off('triggerReportOnePay', this.clickPay);
    },
    methods: {
        clickPay(params) {
            console.log('clickPay--------', this.productData.pid, this.marriageData.id)
            // 会员特权免费解锁
            if(this.userData && this.userData.vip >= 30) {
                this.$store.dispatch('marriage/vipUnlockMarriageReport', {
                    sucCb: ()=> {
                        this.showMarriageReportSuc();
                        this.$store.dispatch('marriage/resetMarriageData');
                        this.$store.dispatch('marriage/getMarriageInfoById', { rData: this.marriageData });
                    },
                    failCb: ()=> {
                        this.$toast('免费解锁失败，请稍后再试');
                    }
                })
                return;
            }

            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : this.productData.payType[2];
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: this.productData.pid,         //支付项目id
                    ptype: payType,                    //支付方式
                    ext: this.marriageData.id          //支付的评测id
                },
                // mixParams: {
                //     pid: params.data.pid,
                //     product_name: params.data.title,
                //     price: params.data.price,
                //     from: 'generate_ai',
                // },
                sucCb: () => {
                    console.log('支付成功，更新合婚报告数据');
                    this.showMarriageReportSuc();
                    // 更新数据
                    this.$store.dispatch('marriage/resetMarriageData');
                    this.$store.dispatch('marriage/getMarriageInfoById', { rData: this.marriageData });

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: ()=> {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        showMarriageReportSuc() {
            // 显示并定时隐藏支付成功提示
            this.showPaySuc = true;
            setTimeout(() => {
                this.showPaySuc = false;
                MARRIAGE_DOM.initMarriagePageHeightList();
                setTimeout(()=> {
                    MARRIAGE_DOM.bindMarriageScrollEvent();
                }, 20);
            }, 3000);
        },
    }
}
</script>